/**
 * Result<T, E> envelope used at every boundary (route, queue handler, lib call).
 * See root claude.md conventions.
 */

export type Result<T, E = AppError> =
  | { ok: true; value: T }
  | { ok: false; error: E };

export const ok = <T>(value: T): Result<T, never> => ({ ok: true, value });
export const err = <E>(error: E): Result<never, E> => ({ ok: false, error });

export type AppErrorCode =
  | "BAD_REQUEST"
  | "UNAUTHORIZED"
  | "FORBIDDEN"
  | "NOT_FOUND"
  | "CONFLICT"
  | "RATE_LIMITED"
  | "UPSTREAM_FAILED"
  | "TIMEOUT"
  | "INTERNAL";

export interface AppError {
  code: AppErrorCode;
  message: string;
  cause?: unknown;
  retriable?: boolean;
}

export const appError = (
  code: AppErrorCode,
  message: string,
  opts: Pick<AppError, "cause" | "retriable"> = {},
): AppError => ({ code, message, ...opts });
